import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { FolderService } from 'src/app/shared/services/folder.service';
import {
  deleteFolder,
  editFolder,
  loadFolder,
  loadFolderSuccess,
  saveFolder,
} from './folder.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class FolderEffects {
  constructor(private service: FolderService, private action$: Actions, private notify: NotifyService) {}

  loadFolder$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadFolder),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadFolderSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveFolder$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveFolder),
      concatMap(({ folder }) =>
        this.service.save(folder).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadFolder()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editFolder$ = createEffect(() =>
    this.action$.pipe(
      ofType(editFolder),
      concatMap(({ folder, id }) =>
        this.service.edit(folder, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadFolder()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteFolder$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteFolder),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadFolder()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
